// @ts-nocheck
import React from 'react';
import { Drawer, DrawerSuspense } from '@/components';
import withDrawers from '@/containers/Drawer/withDrawers';

import { compose } from '@/utils';

const PurchaseOrderDrawerContent = React.lazy(() => import('./PurchaseOrderDrawerContent'));

/**
 * Bill drawer.
 */
function PurchaseOrderDrawer({
  name,
  // #withDrawer
  isOpen,
  payload: { purchaseOrderId },
}) {
  return (
    <Drawer
      isOpen={isOpen}
      name={name}
      style={{ minWidth: '700px', maxWidth: '900px' }}
      size={'65%'}
    >
      <DrawerSuspense>
        <PurchaseOrderDrawerContent purchaseOrderId={purchaseOrderId} />
      </DrawerSuspense>
    </Drawer>
  );
}

export default compose(withDrawers())(PurchaseOrderDrawer);
